import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const testimonials = [{
  quote: 'Le pasé las fotos del taller un martes y el miércoles ya tenía la web andando. Ahora los clientes me escriben directo por WhatsApp.',
  name: 'Marcelo Ríos',
  role: 'Taller Ríos',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/32426011-b324-494d-b5dc-ce7382cedd3d.jpg'
}, {
  quote: 'Pensé que iba a ser complicado y fue todo por mensajes. Me encantó el diseño y triplicamos los turnos del mes.',
  name: 'Carolina Duarte',
  role: 'Estética Bloom',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/7910d3b2-6f42-4688-8f55-4a90062b5d35.jpg'
}, {
  quote: 'Precio claro, sin vueltas y con dominio propio. En un día tenía la carta online y las reservas funcionando.',
  name: 'Nicolás Ferrer',
  role: 'Parrilla Don Nico',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/115d5613-9bc1-40f4-8539-a3a62abaa494.jpg'
}];
export function Testimonials() {
  return <section className="w-full bg-[#FAFAFA] py-20 sm:py-28" data-id="element-160" data-mp="m6m5jgzm4o5r">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-161" data-mp="78k2r90eo6pk">
        <SectionHeading eyebrow="Testimonios" title="Negocios que ya están online" description="Historias reales de clientes que pasaron de no tener web a recibir consultas al día siguiente." data-id="element-162" data-mp="7a4z946a5zq2" />

        <div className="mt-14 grid gap-6 md:grid-cols-3" data-id="element-163" data-mp="14w2d2o9ptgvo">
          {testimonials.map((item, index) => <motion.figure key={item.name} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.45,
          delay: index * 0.08,
          ease: [0.22, 1, 0.36, 1]
        }} className="flex h-full flex-col rounded-3xl border border-black/5 bg-white p-8 shadow-soft" data-id="element-164" data-mp="q7efkcgb6x33" data-mpi={index}>
              <div className="flex gap-1" aria-label="5 de 5 estrellas" data-id="element-165" data-mp="1xhh5runo19l5">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-brand-yellow text-brand-yellow" aria-hidden="true" data-id="element-166" data-mp="1sh34cvgkkxw3" data-mpi={i} />)}
              </div>
              <blockquote className="mt-5 flex-1 text-sm leading-relaxed text-brand-ink/70" data-id="element-167" data-mp="1jh6ggw208323">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-7 flex items-center gap-3" data-id="element-168" data-mp="19seqgtgi7stt">
                <img src={item.image} alt={item.name} className="h-11 w-11 rounded-full object-cover" loading="lazy" data-id="element-169" data-mp="19r3masj5cj26" />
                <span className="text-sm font-bold leading-tight" data-id="element-170" data-mp="10tku947354gs">
                  {item.name}
                  <span className="block text-xs font-medium text-brand-ink/50" data-id="element-171" data-mp="vrvni0qwbcyi">{item.role}</span>
                </span>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}